<template>
    <div class="header">
        <transition name="expand">
        <div 
            class="warning top" 
            :style="[($route.path === '/') ? { 'height': '100px' } : { 'height': '0', 'border': 'none', 'color': '#00000000' }]"
        >
            WARNING: These products contain nicotine.
            <br/>
            Nicotine is an addictive substance.
        </div>
        </transition>
        <nav :class="[scrollTop ? 'top' : 'scrolled']" :style="[]">
            <div class="first-time">First Time Customers Get 10% OFF</div>
            <div id="brand" :style="{backgroundImage: `url(${require('../assets/logos/VAPEQUEEN-2-.png')})`}"></div>
            <ul id="menu">
                <span class="nav-link"><router-link tag="li" to="/">Home</router-link> / </span>
                <span class="nav-link"><router-link tag="li" to="/newsfeed">Newsfeed</router-link> / </span>
                <span class="nav-link"><router-link tag="li" to="/about">About Us</router-link> / </span>
                <span class="nav-link"><router-link tag="li" to="/why-vape">Why Vape</router-link> / </span>
                <span class="nav-link"><router-link tag="li" to="/why-cbd">Why CBD</router-link> / </span>
                <span class="nav-link"><router-link tag="li" to="/flavors">Flavors</router-link> / </span>
                <span class="nav-link"><router-link tag="li" to="/products">Products</router-link> / </span>
                <span class="nav-link"><router-link tag="li" to="/contact">Contact Us</router-link></span>
            </ul>

            <div id="toggle" :class="{on: toggleActive}" style="height: 0">
				<div class="expand" @click="toggleActive = !toggleActive">
					<div class="span" id="one"></div>
					<div class="span" id="two"></div>
					<div class="span" id="three"></div>
				</div>
            </div>
        </nav>

        <div id="resize" :class="{ active: toggleActive }">
            <ul id="menu">
                <router-link tag="li" to="/" @click.native="toggleActive = false"><span>Home</span></router-link>
                <router-link tag="li" to="/newsfeed" @click.native="toggleActive = false"><span>Newsfeed</span></router-link>
                <router-link tag="li" to="/about" @click.native="toggleActive = false"><span>About Us</span></router-link>
                <router-link tag="li" to="/why-vape" @click.native="toggleActive = false">Why Vape</router-link>
                <router-link tag="li" to="/why-cbd" @click.native="toggleActive = false">Why CBD</router-link>
                <router-link tag="li" to="/flavors" @click.native="toggleActive = false">Flavors</router-link>
                <router-link tag="li" to="/products" @click.native="toggleActive = false">Products</router-link>
                <router-link tag="li" to="/contact" @click.native="toggleActive = false">Contact Us</router-link>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            toggleActive: false,
            scrollTop: true
        }
    },
    methods: {
        scrollHandler() {
            if (window.scrollY < 110) this.scrollTop = true
            else this.scrollTop = false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollHandler)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollHandler)
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans');

.warning.top {
    display: flex;
    border-top: 3px solid black;
    border-bottom: 3px solid black;
    background: white;
    height: 100px;
    align-items: center;
    justify-content: center;
    font-family: Nunito Sans;
    font-weight: bold;
    font-size: 1.5em;
    text-align: center;
    transition: 1s;
}

.first-time {
    width: 100%;
    padding: 5px;
    text-align: center;
    background-image: linear-gradient(to left, #e5e5e5, #cdace4 64%);
    font-family: Josefin Sans;
}

.nav-link {
    font-family: Nunito Sans;
    font-weight: bold;
    font-size: 1.0em;
    color: white;
}

@keyframes slidein {
    from {
        margin-top: -100px;
    }
    to {
        margin-top: 0px;
    }
}

nav {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    &.top {
        // margin-bottom: 60px;
        background: #97d3ceee;
        height: 175px;
        z-index: 1;
        width: 100%;
        transition: all 0.5s ease;
        #menu {
            .nav-link {
                color: white;
            }
            li {
                color: white;
            }
        }
    }
    &.scrolled {
        background: #97d3ceee;
        z-index: 1;
        position: fixed;
        width: 100%;
        animation-duration: 0.5s;
        animation-name: slidein;
        top: 0;
        height: 75px;
        #brand {
            display: none;
        }
    }
    #brand {
        background-size: contain; 
        background-repeat: no-repeat; 
        // background-color: #97d3ceee;
        width: 100px; 
        height: 100px;
        border-radius: 100%;
        &:before {
            background-color: #212121
        }
    }
    #menu {
        margin-bottom: 5px;
        li {
            display: inline-block;
            padding: 0px 10px;
            cursor: pointer;
            line-height: 40px;
            position: relative;
            transition: all 0.3s ease-out;
            color: #AAA;
            color: white;
            font-family: Nunito Sans;
            font-size: 1.0em;
			&:hover {
				color: #d8c6e4;
			}
        }
    }
}

nav #menu li.router-link-exact-active {
    color: #black;
}

#toggle {
  z-index: 2;
  height: 40px;
  width: 100%;
  transition: all 0.3s ease-out;
  visibility: hidden;
  opacity: 0;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 3px;
  margin-right: 10px;
}

#toggle .expand {
  cursor: pointer;
  width: 40px;
}

#toggle .span {
  width: 40px;
  height: 7px;
  background: #333;
  margin: 5px auto;
  backface-visibility: hidden;
}

#toggle.on .expand #one {
  transform: rotate(45deg) translateX(6px) translateY(6px);
}

#toggle.on .expand #two {
  opacity: 0;
}

#toggle.on .expand #three {
  transform: rotate(-45deg) translateX(10px) translateY(-12px);
}

#resize {
  font-family: Nunito Sans;
  z-index: 1;
  position: fixed;
  top: 75px;
  right: 0;
  background: #97d3ceee;
  width: 50%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s ease-out;
  display: table;
}

#resize #menu {
  height: 50px;
  display: table-cell;
  vertical-align: right;
}

#resize #menu li {
  display: block;
  padding: 20px 0;
  padding-right: 20px;
  text-align: right;
  font-size: 2em;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease-out;
}

#resize #menu li:hover {
  background: #212121;
}

#resize #menu li:hover a {
  color: #fff;
  transition: all 0.3s ease-out;
}

#resize #menu li a {
  color: #212121;
}

#resize.active {
  visibility: visible;
  opacity: 0.99;
}

@media (max-width: 768px) {
  #toggle {
    visibility: visible;
	height: 40px !important;
    opacity: 1;
  }
  #brand {
      display: none;
  }
  nav.top {
      align-items: center;
      height: 75px;
  }
  nav #menu {
    display: none;
  }
}

@media (min-width: 768px) {
  #resize {
    visibility: hidden !important;
  }
}
</style>
